import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}
interface State {
  error: Error | null;
}

/** Catches render errors in a subtree so one broken section doesn't blank the app. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[ErrorBoundary]", error);
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: "2rem", textAlign: "center", color: "var(--kd-text-muted)" }}>
            <p style={{ fontSize: "1.1rem", marginBottom: 8 }}>⚠️ Something went wrong loading this section.</p>
            <p style={{ fontSize: "0.85rem", opacity: 0.7 }}>{this.state.error.message}</p>
            <button className="kd-btn-secondary" style={{ marginTop: 16 }} onClick={() => this.setState({ error: null })}>
              Retry
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
